import styled from 'styled-components';

const contSidebar = styled.div`
    height: 100%;
    transition: all ease-in 0.01s;
    width:100%;
    background-color:rgba(0,0,0,0.4);
    backdrop-filter: blur(8px);
    position: fixed;
    left:0;
    top:0;
    right:0;
    bottom:0;
    transform: translateX(${props=> props.active ? '0px' : '-2000px'});
    z-index:100000;
`;

const cont = styled.div`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    min-width: 320px;
    width: fit-content;
    height: 100%;
    background: #fff;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    justify-content:flex-start;
    align-items:center;
    padding:1.5rem;
    transition: all ease-in 0.3s;
    overflow-y: auto;
    transform: translateX(${props => props.active ? '0px' : '-350px'});
    
    /* width */
    ::-webkit-scrollbar {
      width: 6px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
      background: #f8f9fa;
      border-radius: 3px;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        border-radius: 3px;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {        
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
    }
`;

const header = styled.div`
    width:100%;
    height: 70px;
    display: flex;
    justify-content:space-between;
    align-items:center;
    font-weight: 600;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    border-bottom: 1px solid #e9ecef;

    p {
        margin-bottom:0;
        font-weight: 700;
        font-size: 1.2rem;
        color: #2c3e50;
        letter-spacing: -0.02em;
    }

    button {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        background: #f8f9fa;
        border: 1px solid #e9ecef;
        display: flex;
        color: #6c757d;
        justify-content: center;
        align-items: center;
        outline: none;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        
        &:hover {
            background: #ef4444;
            color: white;
            border-color: #ef4444;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
        }
    }
`

const AnotherMenuCss = {
    contSidebar,
    cont,
    header
}

export default AnotherMenuCss;